import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
import { db, firebase } from '../../firebase/Firebase'
import ColType from '../.././Types'
//import CustomFooter from '../../login/CustomFooter'
//import SubjectHistogram from '../../admin/SubjectHistogram'
//import SupportPieChartTiers from '../../admin/SupportPieChartTiers'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
//import Empty from '../../customcomponents/Empty'
//import { getIDFromURL } from '../.././Util'
//import PacingGuideSC from './PacingGuideSC'
import { Layout, Select, Icon, Tabs, Button, notification, Collapse, Popconfirm, Checkbox, Input } from 'antd'
//import PacingGuideAssessment from './PacingGuideAssessment'
//import ComponentFactory from '../edviz/ComponentFactory'
import { getQueryStringParam, flattenDoc, cleverStartQuiz, getQuarterAndWeekFromNum, shuffleArray, manualCheckAssessment, injectBaseHref } from '../../Util'
import DocumentDelegator from '../../edviz/EdvizDelegator'
import PacingGuideUploads from './PacingGuideUploads'
//import PacingGuideFeedback from './PacingGuideFeedback'
import PacingGuideAssessmentModalForm from './PacingGuideAssessmentModalForm'
import HTMLAssessmentViewer from '../html/components/HTMLAssessmentViewer.js'
import StudentResource from './StudentResource.js'
import ReactToPrint from "react-to-print"
//import LessonPlanPDFDownload from './LessonPlanPDF'
const Sider = Layout.Sider
const Content = Layout.Content
// Renders the lesson plan components as a PowerPoint-style slide deck.
// A slide menu on the left lets you pick a slide; the selected slide's
// components are rendered on the right using the existing DocumentDelegator.
// Sections are split into sub-slides at each "Smart Move" boundary, and the
// deck can be presented full screen (with an optional teacher-notes toggle).
class LessonPlanSlides extends Component {
    state = {
        activeIndex: 0,
        fullScreen: false,
        // teacher notes are hidden by default while presenting full screen
        showTeacherNotes: false,
        showMenuInFullScreen: false,
    }
    // Section headings (in priority order). The longer "Materials" variant
    // must be checked before the short one so it normalizes correctly.
    sectionNames = [
        'Objective',
        "Materials (what you'll use)",
        'Materials',
        'Present the Standard',
        'Engage with the Standard',
        'Master the Standard',
        'Differentiated Activities',
    ]
    sectionIcons = {
        'Overview': 'file-text',
        'Objective': 'flag',
        'Materials': 'appstore',
        'Present the Standard': 'read',
        'Engage with the Standard': 'team',
        'Master the Standard': 'trophy',
        'Differentiated Activities': 'cluster',
    }
    componentDidMount() {
        document.addEventListener('fullscreenchange', this.onFullScreenChange)
        document.addEventListener('webkitfullscreenchange', this.onFullScreenChange)
        document.addEventListener('keydown', this.onKeyDown)
    }
    componentWillUnmount() {
        document.removeEventListener('fullscreenchange', this.onFullScreenChange)
        document.removeEventListener('webkitfullscreenchange', this.onFullScreenChange)
        document.removeEventListener('keydown', this.onKeyDown)
    }
    componentDidUpdate(prevProps) {
        // reset to the first slide when a different lesson plan is loaded
        if (prevProps.components !== this.props.components) {
            this.setState({ activeIndex: 0 })
        }
    }
    // ---- text helpers ----------------------------------------------------
    extractTextFromArray = (arr) => {
        let text = ''
        arr.forEach((item) => {
            if (typeof item === 'string') {
                text += ' ' + item
            } else if (item && typeof item === 'object') {
                text += ' ' + this.getPlainText(item)
            }
        })
        return text
    }
    // Best-effort plain text from an edviz component (handles string fields,
    // rich-text arrays, and nested children), with html/markdown stripped.
    getPlainText = (component) => {
        if (!component) {
            return ''
        }
        if (typeof component === 'string') {
            return component
        }
        let text = ''
        const fields = ['content', 'heading', 'text', 'value', 'title']
        fields.forEach((f) => {
            if (component.hasOwnProperty(f)) {
                const v = component[f]
                if (typeof v === 'string') {
                    text += ' ' + v
                } else if (Array.isArray(v)) {
                    text += ' ' + this.extractTextFromArray(v)
                }
            }
        })
        if (component.hasOwnProperty('children') && Array.isArray(component.children)) {
            text += ' ' + this.extractTextFromArray(component.children)
        }
        text = text.replace(/<[^>]*>/g, ' ').replace(/[*_#`]/g, ' ')
        return text.replace(/\s+/g, ' ').trim()
    }
    isSmartMove = (component) => {
        return /^\s*smart\s*move\b/i.test(this.getPlainText(component))
    }
    isTeacherNote = (component) => {
        return /^\s*teacher\s*note\b/i.test(this.getPlainText(component))
    }
    // Returns the normalized section title if this component is one of the
    // known section headings, otherwise null.
    getSectionTitle = (component) => {
        if (!component) {
            return null
        }
        let candidates = []
        if (component.hasOwnProperty('content') && typeof component.content === 'string') {
            candidates.push(component.content.trim())
        }
        if (component.hasOwnProperty('heading') && typeof component.heading === 'string') {
            candidates.push(component.heading.trim())
        }
        for (let c = 0; c < candidates.length; c++) {
            let candidate = candidates[c]
            for (let i = 0; i < this.sectionNames.length; i++) {
                let name = this.sectionNames[i]
                if (candidate.toLowerCase() === name.toLowerCase()) {
                    if (name === "Materials (what you'll use)" || name === 'Materials') {
                        return 'Materials'
                    }
                    return name
                }
            }
        }
        return null
    }
    // Title for a sub-slide: the bold lead-in phrase before the first colon
    // (e.g. "Explicit Introduction: ..." -> "Explicit Introduction").
    getSubSlideTitle = (slideComponents, fallback) => {
        for (let i = 0; i < slideComponents.length; i++) {
            const c = slideComponents[i]
            if (this.isSmartMove(c) || this.isTeacherNote(c)) {
                continue
            }
            const text = this.getPlainText(c)
            if (!text) {
                continue
            }
            const colonIdx = text.indexOf(':')
            if (colonIdx > 0 && colonIdx <= 60) {
                return text.substring(0, colonIdx).trim()
            }
            return text.split(' ').slice(0, 5).join(' ')
        }
        return fallback
    }
    // Split a section's components into sub-slides. Each "Smart Move" marks the
    // end of a slide, so a new slide begins at the next lead-in block - except
    // after the final Smart Move, so trailing content (e.g. "Extension") stays
    // attached to the last slide rather than spawning an empty one.
    splitSectionIntoSlides = (section) => {
        const comps = section.components || []
        let smartMoveIndices = []
        comps.forEach((c, i) => {
            if (this.isSmartMove(c)) {
                smartMoveIndices.push(i)
            }
        })
        // 0 or 1 Smart Move -> a single slide for the whole section
        if (smartMoveIndices.length <= 1) {
            return [{
                title: section.title,
                sectionTitle: section.title,
                isSubSlide: false,
                components: comps,
            }]
        }
        const lastSmartMoveIndex = smartMoveIndices[smartMoveIndices.length - 1]
        let groups = []
        let current = []
        let currentHasSmartMove = false
        for (let i = 0; i < comps.length; i++) {
            const c = comps[i]
            const sm = this.isSmartMove(c)
            const tn = this.isTeacherNote(c)
            // begin a new slide before a lead-in block, but only once the current
            // slide already holds a Smart Move and another Smart Move still follows
            if (!sm && !tn && currentHasSmartMove && i <= lastSmartMoveIndex) {
                groups.push(current)
                current = []
                currentHasSmartMove = false
            }
            current.push(c)
            if (sm) {
                currentHasSmartMove = true
            }
        }
        if (current.length) {
            groups.push(current)
        }
        return groups.map((group, idx) => {
            return {
                title: idx === 0 ? section.title : this.getSubSlideTitle(group, section.title),
                sectionTitle: section.title,
                isSubSlide: idx !== 0,
                components: group,
            }
        })
    }
    // Group the flat component list into sections by the known section headings.
    getSections = () => {
        const components = this.props.components || []
        let sections = []
        let preface = []
        components.forEach((component) => {
            let sectionTitle = this.getSectionTitle(component)
            if (sectionTitle) {
                // start a new section, the heading itself becomes the slide title
                sections.push({ title: sectionTitle, components: [] })
            } else if (sections.length > 0) {
                sections[sections.length - 1].components.push(component)
            } else {
                // any content before the first known heading
                preface.push(component)
            }
        })
        if (preface.length > 0) {
            sections.unshift({ title: 'Overview', components: preface })
        }
        return sections
    }
    // Flat list of every slide (sections expanded into their sub-slides).
    getSlides = () => {
        let sections = this.getSections()
        let slides = []
        sections.forEach((section) => {
            slides = slides.concat(this.splitSectionIntoSlides(section))
        })
        return slides
    }
    goToSlide = (idx) => {
        const slides = this.getSlides()
        if (!slides.length) {
            return
        }
        let next = idx
        if (next < 0) {
            next = 0
        }
        if (next > slides.length - 1) {
            next = slides.length - 1
        }
        this.setState({ activeIndex: next })
    }
    // ---- copy / paste ----------------------------------------------------
    // Equations come through as math wrapped in $...$ or $$...$$ (rendered as
    // MathJax SVG, so the text can't be read back from the DOM). Strip the math
    // delimiters here so the copied text shows the plain number/expression.
    stripMath = (s) => {
        if (!s) {
            return ''
        }
        return s
            .replace(/\$\$([^$]*)\$\$/g, '$1')
            .replace(/\$([^$]*)\$/g, '$1')
    }
    // Walk a component / inline node (string, array, or object) into plain text.
    nodeToText = (node) => {
        if (node === null || node === undefined) {
            return ''
        }
        if (typeof node === 'string') {
            return this.stripMath(node)
        }
        if (Array.isArray(node)) {
            return node.map((n) => this.nodeToText(n)).join('')
        }
        if (typeof node.content === 'string') {
            return this.stripMath(node.content)
        }
        if (Array.isArray(node.content)) {
            return node.content.map((n) => this.nodeToText(n)).join('')
        }
        if (typeof node.heading === 'string') {
            return this.stripMath(node.heading)
        }
        return ''
    }
    // Serialize the whole lesson plan to plain text for copy/paste.
    componentsToText = (components) => {
        let out = []
        let first = true;
        (components || []).forEach((comp) => {
            if (!comp) {
                return
            }
            const type = comp.type || ''
            const isHeading = (typeof comp.heading === 'string') || /^H[1-6]$/.test(type)
            if (isHeading) {
                if (!first) {
                    out.push('') // blank line before each section heading
                }
                out.push(this.nodeToText(comp.heading || comp.content))
            } else if (type === 'ItemList' && Array.isArray(comp.items)) {
                comp.items.forEach((item) => {
                    out.push('- ' + this.nodeToText(item))
                })
            } else {
                const text = this.nodeToText(comp.content)
                if (text && text.trim()) {
                    out.push(text)
                }
            }
            first = false
        })
        return out.join('\n').replace(/\n{3,}/g, '\n\n').trim()
    }
    fallbackCopy = (text, onOk, onErr) => {
        try {
            const ta = document.createElement('textarea')
            ta.value = text
            ta.style.position = 'fixed'
            ta.style.left = '-9999px'
            document.body.appendChild(ta)
            ta.select()
            const ok = document.execCommand('copy')
            document.body.removeChild(ta)
            if (ok) {
                onOk()
            } else {
                onErr()
            }
        } catch (e) {
            onErr()
        }
    }
    copyLessonPlan = () => {
        const text = this.componentsToText(this.props.components)
        const onOk = () => notification.open({
            type: 'success',
            duration: 3,
            message: 'Lesson plan copied to clipboard',
            placement: 'bottomRight'
        })
        const onErr = () => notification.open({
            type: 'error',
            duration: 4,
            message: 'Could not copy automatically. Please select the text and copy manually.',
            placement: 'bottomRight'
        })
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(onOk).catch(() => this.fallbackCopy(text, onOk, onErr))
        } else {
            this.fallbackCopy(text, onOk, onErr)
        }
    }
    // ---- full screen -----------------------------------------------------
    onFullScreenChange = () => {
        // keep state in sync when the browser exits full screen (Esc / F11)
        const fsElement = document.fullscreenElement || document.webkitFullscreenElement
        if (!fsElement && this.state.fullScreen) {
            this.setState({ fullScreen: false })
        }
    }
    onKeyDown = (e) => {
        if (!this.state.fullScreen) {
            return
        }
        if (e.key === 'Escape') {
            this.exitFullScreen()
        } else if (e.key === 'ArrowRight' || e.key === 'PageDown') {
            e.preventDefault()
            this.goToSlide(this.state.activeIndex + 1)
        } else if (e.key === 'ArrowLeft' || e.key === 'PageUp') {
            e.preventDefault()
            this.goToSlide(this.state.activeIndex - 1)
        }
    }
    enterFullScreen = () => {
        this.setState({ fullScreen: true }, () => {
            const el = this.deckRef
            if (!el) {
                return
            }
            const req = el.requestFullscreen || el.webkitRequestFullscreen ||
                el.mozRequestFullScreen || el.msRequestFullscreen
            if (req) {
                try {
                    req.call(el)
                } catch (e) {
                    // the fixed-overlay fallback below still gives a full-screen view
                }
            }
        })
    }
    exitFullScreen = () => {
        const fsElement = document.fullscreenElement || document.webkitFullscreenElement
        if (fsElement) {
            const exit = document.exitFullscreen || document.webkitExitFullscreen ||
                document.mozCancelFullScreen || document.msExitFullscreen
            if (exit) {
                try {
                    exit.call(document)
                } catch (e) {
                    // ignore
                }
            }
        }
        this.setState({ fullScreen: false })
    }
    // ---- rendering -------------------------------------------------------
    renderMenu = (slides, activeIndex, fullScreen) => {
        const menuWidth = fullScreen ? 340 : 280
        return (
            <div style={{
                width: menuWidth + 'px',
                flex: '0 0 ' + menuWidth + 'px',
                position: 'sticky',
                top: '16px',
            }}>
                <div className='background-fff br-15 p-2 ant-shadow'>
                    <div className='font-bold ml-2 mt-1 mb-2'
                        style={{ color: '#1e293b', fontSize: fullScreen ? '20px' : '16px' }}>
                        Slides
                    </div>
                    {slides.map((slide, idx) => {
                        const isActive = idx === activeIndex
                        if (slide.isSubSlide) {
                            return (
                                <div
                                    key={'lesson-slide-' + idx}
                                    onClick={() => this.goToSlide(idx)}
                                    className='br-15 mb-1 flex flex-v-center'
                                    style={{
                                        cursor: 'pointer',
                                        padding: fullScreen ? '12px 14px 12px 34px' : '10px 14px 10px 30px',
                                        backgroundColor: isActive ? '#2d6a9f' : 'transparent',
                                        color: isActive ? '#fff' : '#5a6679',
                                        transition: 'all 0.15s ease',
                                    }}
                                >
                                    <Icon type='caret-right' className='mr-2'
                                        style={{ fontSize: fullScreen ? '14px' : '12px', opacity: 0.7 }} />
                                    <div style={{
                                        fontSize: fullScreen ? '18px' : '15px',
                                        fontWeight: isActive ? 600 : 400,
                                        lineHeight: 1.25,
                                    }}>
                                        {slide.title}
                                    </div>
                                </div>
                            )
                        }
                        const iconType = this.sectionIcons.hasOwnProperty(slide.title) ?
                            this.sectionIcons[slide.title] : 'profile'
                        const iconBox = fullScreen ? 36 : 30
                        return (
                            <div
                                key={'lesson-slide-' + idx}
                                onClick={() => this.goToSlide(idx)}
                                className='br-15 mb-1 flex flex-v-center'
                                style={{
                                    cursor: 'pointer',
                                    padding: fullScreen ? '14px 14px' : '12px 14px',
                                    backgroundColor: isActive ? '#2d6a9f' : 'transparent',
                                    color: isActive ? '#fff' : '#1e293b',
                                    transition: 'all 0.15s ease',
                                }}
                            >
                                <div className='flex flex-v-center flex-h-center' style={{
                                    width: iconBox + 'px',
                                    height: iconBox + 'px',
                                    borderRadius: '8px',
                                    backgroundColor: isActive ? 'rgba(255,255,255,0.18)' : '#f0f2f5',
                                    marginRight: '12px',
                                    flex: '0 0 ' + iconBox + 'px',
                                }}>
                                    <Icon type={iconType} style={{ fontSize: fullScreen ? '20px' : '16px' }} />
                                </div>
                                <div style={{
                                    fontSize: fullScreen ? '20px' : '16px',
                                    fontWeight: isActive ? 600 : 400,
                                    lineHeight: 1.25,
                                }}>
                                    {slide.title}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
    renderContent = (slides, activeIndex, activeSlide, fullScreen) => {
        // hide teacher notes while presenting full screen unless toggled on
        let displayComponents = activeSlide.components
        if (fullScreen && !this.state.showTeacherNotes) {
            displayComponents = displayComponents.filter((c) => !this.isTeacherNote(c))
        }
        const iconType = this.sectionIcons.hasOwnProperty(activeSlide.sectionTitle) ?
            this.sectionIcons[activeSlide.sectionTitle] : 'profile'
        const menuVisible = !fullScreen || this.state.showMenuInFullScreen
        return (
            <div style={{ flex: '1 1 auto', paddingLeft: menuVisible ? '24px' : 0, minWidth: 0 }}>
                {fullScreen ?
                    <style>{`
                    /* every element in the slide follows the full-screen size; the id
                       outranks the edviz list styles */
                    #lesson-slide-fs *,
                    #lesson-slide-fs ul, #lesson-slide-fs ol, #lesson-slide-fs li,
                    #lesson-slide-fs ul *, #lesson-slide-fs ol * {
                        font-size: inherit !important;
                        line-height: inherit !important;
                    }
                    /* headings scale relative to the slide text */
                    #lesson-slide-fs h1, #lesson-slide-fs [class*="heading-1"] { font-size: 1.5em !important; line-height: 1.2 !important; }
                    #lesson-slide-fs h2, #lesson-slide-fs [class*="heading-2"] { font-size: 1.3em !important; line-height: 1.25 !important; }
                    #lesson-slide-fs h3, #lesson-slide-fs h4,
                    #lesson-slide-fs [class*="heading-3"], #lesson-slide-fs [class*="heading-4"] { font-size: 1.15em !important; line-height: 1.3 !important; }
                    #lesson-slide-fs li { margin-bottom: 0.4em; }
                    #lesson-slide-fs p { margin-bottom: 0.6em; }
                    #lesson-slide-fs img { max-width: 100%; height: auto; }
                `}</style>
                    : ''}
                <div className={'background-fff br-15 ant-shadow' + (fullScreen ? '' : ' p-4')}
                    style={fullScreen ? {
                        padding: '40px 56px',
                        margin: '0 auto',
                        maxWidth: '1600px',
                        minHeight: 'calc(100vh - 110px)',
                    } : {
                        marginBottom: '16px',
                    }}>
                    <div className={'flex flex-v-center' + (fullScreen ? '' : ' mb-3')}
                        style={fullScreen ? { marginBottom: 28 } : {}}>
                        <div className='flex flex-v-center flex-h-center' style={{
                            width: fullScreen ? '72px' : '44px',
                            height: fullScreen ? '72px' : '44px',
                            borderRadius: fullScreen ? '14px' : '12px',
                            backgroundColor: '#2d6a9f',
                            color: '#fff',
                            marginRight: fullScreen ? '20px' : '16px',
                            flex: fullScreen ? '0 0 72px' : '0 0 44px',
                        }}>
                            <Icon type={iconType} style={{ fontSize: fullScreen ? '40px' : '24px' }} />
                        </div>
                        <h1 className='edviz-document-v2-heading-1'
                            style={fullScreen ? {
                                margin: 0,
                                lineHeight: 1.15,
                                fontSize: 'clamp(40px, 3.4vw, 64px)',
                            } : { margin: 0 }}>
                            {activeSlide.title}
                        </h1>
                        <div className={'ml-auto' + (fullScreen ? '' : ' font-16')}
                            style={fullScreen ?
                                { color: '#8c98a8', fontSize: 24, whiteSpace: 'nowrap', paddingLeft: 16 } :
                                { color: '#8c98a8' }}>
                            {(activeIndex + 1) + ' / ' + slides.length}
                        </div>
                    </div>
                    {activeSlide.isSubSlide ?
                        <div className={fullScreen ? '' : 'font-16 mb-2'}
                            style={fullScreen ?
                                { color: '#8c98a8', fontSize: 24, marginBottom: 12 } :
                                { color: '#8c98a8' }}>
                            {activeSlide.sectionTitle}
                        </div>
                        : ''}
                    <div id={fullScreen ? 'lesson-slide-fs' : undefined}
                        className={fullScreen ? 'lesson-slide-body-fs' : ''}
                        style={{
                            // scales with the screen when presenting
                            fontSize: fullScreen ? 'clamp(28px, 2.3vw, 42px)' : '24px',
                            lineHeight: fullScreen ? 1.5 : 1.6,
                        }}>
                        <DocumentDelegator
                            document={{
                                components: displayComponents,
                                metadata: { 'edvizVersion': '2' }
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
    render() {
        const mode = this.props.mode || 'slides'
        // Step 1 view — the full lesson plan as readable text, with a copy button.
        if (mode === 'copy') {
            return (
                <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                    <div className='flex flex-v-center mb-3'>
                        <Button type='primary' size='large'
                            className='lg-btn inline-flex flex-v-center'
                            onClick={this.copyLessonPlan}>
                            <Icon type='copy' className='font-20 mr-1' />
                            <span>Copy lesson plan</span>
                        </Button>
                        <div className='ml-2 font-16' style={{ color: '#8c98a8' }}>
                            Copies the full plan as plain text
                        </div>


                        <ReactToPrint
                            trigger={() =>
                                <Button
                                    size={'large'}
                                    type='primary'
                                    className="lg-btn ml-4"
                                >
                                    <Icon type="printer" />
                                    Print Lesson Plan
                                </Button>
                            }
                            content={() => this.lessonPlanComponentRef}
                        />
                    </div>
                    <div ref={el => (this.lessonPlanComponentRef = el)}>
                        <div className='print-student-resource print-lesson-plan'>
                            <div className='background-fff p-4 br-15 ant-shadow' style={{ marginBottom: '16px' }}>
                                <div className='font-20'>
                                    <DocumentDelegator
                                        document={{
                                            components: this.props.components,
                                            metadata: { 'edvizVersion': '2' }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        const slides = this.getSlides()
        if (!slides.length) {
            return ''
        }
        let activeIndex = this.state.activeIndex
        if (activeIndex < 0 || activeIndex >= slides.length) {
            activeIndex = 0
        }
        const activeSlide = slides[activeIndex]
        const fullScreen = this.state.fullScreen
        const slidesDeck = (
            <div>
                {/* Toolbar above the slides (normal mode) */}
                {!fullScreen ?
                    <div className='flex flex-v-center mb-3'>
                        <Checkbox
                            checked={this.state.showTeacherNotes}
                            onChange={(e) => this.setState({ showTeacherNotes: e.target.checked })}
                        >
                            <span className='font-16 ml-1'>Show teacher notes when presenting</span>
                        </Checkbox>
                        <Button type='primary' size='large'
                            className='lg-btn inline-flex flex-v-center ml-3'
                            onClick={this.enterFullScreen}>
                            <Icon type='fullscreen' className='font-20 mr-1' />
                            <span>Present full screen</span>
                        </Button>
                    </div>
                    : ''}
                <div
                    ref={(r) => { this.deckRef = r }}
                    style={fullScreen ? {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#eef0f3',
                        zIndex: 9999,
                        padding: '20px 28px',
                        overflow: 'auto',
                    } : {}}
                >
                    {/* Presentation controls (full screen only) */}
                    {fullScreen ?
                        <div className='flex flex-v-center mb-3'>
                            <Button size='large'
                                className='lg-btn inline-flex flex-v-center'
                                onClick={() => this.setState({ showMenuInFullScreen: !this.state.showMenuInFullScreen })}>
                                <Icon type={this.state.showMenuInFullScreen ? 'menu-fold' : 'menu-unfold'} className='font-20 mr-1' />
                                <span>{this.state.showMenuInFullScreen ? 'Hide slide list' : 'Show slide list'}</span>
                            </Button>
                            <Button size='large'
                                className='lg-btn inline-flex flex-v-center ml-2'
                                disabled={activeIndex === 0}
                                onClick={() => this.goToSlide(activeIndex - 1)}>
                                <Icon type='left' className='font-20 mr-1' />
                                <span>Previous</span>
                            </Button>
                            <Button type='primary' size='large'
                                className='lg-btn inline-flex flex-v-center ml-2'
                                disabled={activeIndex === slides.length - 1}
                                onClick={() => this.goToSlide(activeIndex + 1)}>
                                <span>Next</span>
                                <Icon type='right' className='font-20 ml-1' />
                            </Button>
                            <div className='ml-auto flex flex-v-center'>
                                <span className='font-16 mr-2' style={{ color: '#8c98a8' }}>
                                    Use arrow keys to navigate &middot; Esc to exit
                                </span>
                                <Button size='large'
                                    className='lg-btn inline-flex flex-v-center'
                                    onClick={this.exitFullScreen}>
                                    <Icon type='close' className='font-20 mr-1' />
                                    <span>Close</span>
                                </Button>
                            </div>
                        </div>
                        : ''}
                    <div className='flex' style={{ alignItems: 'flex-start' }}>
                        {(!fullScreen || this.state.showMenuInFullScreen) ?
                            this.renderMenu(slides, activeIndex, fullScreen) : ''}
                        {this.renderContent(slides, activeIndex, activeSlide, fullScreen)}
                    </div>
                </div>
            </div>
        )
        return slidesDeck
    }
}
// A simple, classroom-friendly wrapper for the student practice resource.
// Adds a "Show answers" toggle and a "Present full screen" option (just like
// the lesson plan slides) so a teacher can either work through the practice
// together on the board, or let students sign in and do it on their own.
class StudentPracticePresenter extends Component {
    state = {
        showAnswers: false,
        fullScreen: false,
    }
    componentDidMount() {
        document.addEventListener('fullscreenchange', this.onFullScreenChange)
        document.addEventListener('webkitfullscreenchange', this.onFullScreenChange)
        document.addEventListener('keydown', this.onKeyDown)
    }
    componentWillUnmount() {
        document.removeEventListener('fullscreenchange', this.onFullScreenChange)
        document.removeEventListener('webkitfullscreenchange', this.onFullScreenChange)
        document.removeEventListener('keydown', this.onKeyDown)
    }
    onFullScreenChange = () => {
        // keep state in sync when the browser exits full screen (Esc / F11)
        const fsElement = document.fullscreenElement || document.webkitFullscreenElement
        if (!fsElement && this.state.fullScreen) {
            this.setState({ fullScreen: false })
        }
    }
    onKeyDown = (e) => {
        if (this.state.fullScreen && e.key === 'Escape') {
            this.exitFullScreen()
        }
    }
    enterFullScreen = () => {
        this.setState({ fullScreen: true }, () => {
            const el = this.containerRef
            if (!el) {
                return
            }
            const req = el.requestFullscreen || el.webkitRequestFullscreen ||
                el.mozRequestFullScreen || el.msRequestFullscreen
            if (req) {
                try {
                    req.call(el)
                } catch (e) {
                    // the fixed-overlay fallback below still gives a full-screen view
                }
            }
        })
    }
    exitFullScreen = () => {
        const fsElement = document.fullscreenElement || document.webkitFullscreenElement
        if (fsElement) {
            const exit = document.exitFullscreen || document.webkitExitFullscreen ||
                document.mozCancelFullScreen || document.msExitFullscreen
            if (exit) {
                try {
                    exit.call(document)
                } catch (e) {
                    // ignore
                }
            }
        }
        this.setState({ fullScreen: false })
    }
    toggleAnswers = () => {
        this.setState({ showAnswers: !this.state.showAnswers })
    }
    renderShowAnswers = () => {
        return <Checkbox
            className='checkbox-lg inline-flex flex-v-center'
            checked={this.state.showAnswers}
            onClick={this.toggleAnswers}>
            <span className='font-20 ml-1' style={{ verticalAlign: '6px' }}>Show answers</span>
        </Checkbox>
    }
    render() {
        const studentResource = this.props.studentResource
        if (!studentResource) {
            return ''
        }
        const fullScreen = this.state.fullScreen
        // toggling answers re-mounts the resource with the answer key shown/hidden
        const resourceContent = <div ref={el => (this.practiceComponentRef = el)}>
            <div className='print-student-resource print-student-practice'>
                {this.state.showAnswers ?
                    <StudentResource
                        key={'resource-' + studentResource.id + '-answers-visible'}
                        savedState={{ showAllCorrectAnswers: true, survey: 'good' }}
                        htmlSource={studentResource.doc} />
                    :
                    <StudentResource
                        key={'resource-' + studentResource.id + '-answers-hidden'}
                        htmlSource={studentResource.doc} />
                }
            </div>
        </div>
        return (
            <div>
                {/* Toolbar (normal mode): show answers + present full screen */}
                {!fullScreen ?
                    <div className='flex flex-v-center mb-3'>
                        {this.renderShowAnswers()}
                        <Button type='primary' size='large'
                            className='lg-btn inline-flex flex-v-center ml-3'
                            onClick={this.enterFullScreen}>
                            <Icon type='fullscreen' className='font-20 mr-1' />
                            <span>Present full screen</span>
                        </Button>
                        <ReactToPrint
                            trigger={() =>
                                <Button
                                    size={'large'}
                                    type='primary'
                                    className="lg-btn ml-2"
                                >
                                    <Icon type="printer" />
                                    Print Student Practice
                                </Button>
                            }
                            content={() => this.practiceComponentRef}
                        />
                    </div>
                    : ''}
                <div
                    ref={(r) => { this.containerRef = r }}
                    style={fullScreen ? {
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: '#eef0f3',
                        zIndex: 9999,
                        padding: '20px 28px',
                        overflow: 'auto',
                    } : {}}
                >
                    {/* Controls (full screen only): show answers + close */}
                    {fullScreen ?
                        <div className='flex flex-v-center mb-3' style={{ maxWidth: '920px', margin: '0 auto' }}>
                            {this.renderShowAnswers()}
                            <div className='ml-auto flex flex-v-center'>
                                <span className='font-16 mr-2' style={{ color: '#8c98a8' }}>
                                    Press Esc to exit
                                </span>
                                <Button size='large'
                                    className='lg-btn inline-flex flex-v-center'
                                    onClick={this.exitFullScreen}>
                                    <Icon type='close' className='font-20 mr-1' />
                                    <span>Close</span>
                                </Button>
                            </div>
                        </div>
                        : ''}
                    <div style={fullScreen ? { maxWidth: '920px', margin: '0 auto' } : {}}>
                        <div className={fullScreen ? 'background-fff p-4 br-15 ant-shadow' : ''}>
                            {resourceContent}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
class PacingGuideLessonPlanV3 extends Component {
    quizComponentRefs = {}

    state = {
        lessonPlan: null,
        lessonPlanFound: true,
        fileURLDict: {},
        activeTab: '',
        lessonPlanStandardNames: ['ELA.1.F.3.6', 'ELA.3.AOR.6.1.a',
            'ELA.6.AOR.1.2', 'ELA.C.1', 'ELA.K.F.1.4', '2.ATO.1', '3.ATO.1',
            '4.ATO.4', '7.RP.2.d', 'A1.AAPR.1', 'K.NS.1', '3-ESS2-1',
            'B-LS1-5', 'USG.1.IP'],
        subjects: ['ELA', 'Math', 'Social Studies', 'Science'],
        lessonPlanStandardNamesSubjectDict: {
            'ELA': ['ELA.K.F.1.4', 'ELA.1.F.3.6', 'ELA.3.AOR.6.1.a',
                'ELA.6.AOR.1.2', 'ELA.C.1'],
            'Math': ['K.NS.1', '2.ATO.1', '3.ATO.1',
                '4.ATO.4', '7.RP.2.d', 'A1.AAPR.1'],
            'Social Studies': ['USG.1.IP'],
            'Science': ['3-ESS2-1', 'B-LS1-5'],
        },
        standardName: '',
        standard: '',
        category: '',
        startingQuiz: false,
        assessments: [],
        selectWeek: '',
        selectIdx: '',
        selectStandard: '',
        fromWeeklyPlanner: false,
        disabledQuizzesDict: {},
        reviewTheseQuizzesDict: {},
        quizzes: [],
        notLiveQuizzes: [],
        quizzesForStandardCategoryAndStandardName: [],
        studentResource: null,
        answersVisible: {
            'resource': false,
            'quiz0': false,
            'quiz1': false,
            'quiz2': false,
            'quiz3': false,
            'quiz4': false,
            'quiz5': false,
        },
        searchQuery: '',
        printingQuizKey: null,
    }
    componentDidMount() {
        let standardName = getQueryStringParam('standardName')
        let standard = getQueryStringParam('standard')
        let category = getQueryStringParam('category')
        let quarter = getQueryStringParam('quarter')
        let week = getQueryStringParam('week')
        let standardIndex = getQueryStringParam('index')
        let fromWeeklyPlanner = getQueryStringParam('weeklyPlanner')
        this.setState({
            selectWeek: week,
            selectIdx: standardIndex,
            selectStandard: standard,
            fromWeeklyPlanner: fromWeeklyPlanner,
        })
        this.getData(standardName, standard, category)
        if (this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.setStandardNameAndCategoryFunc &&
            (this.props.pacingGuideBaseProps.standardName !== standardName ||
                this.props.pacingGuideBaseProps.standardCategory !== category)) {
            if (this.props.pacingGuideBaseProps.mounted) {
                this.props.pacingGuideBaseProps.setStandardNameAndCategoryFunc(
                    standardName, category
                )
            } else {
                // wait for base component to mount before calling func
                let baseMountedInterval = setInterval(() => {
                    if (this.props.pacingGuideBaseProps.mounted &&
                        this.props.pacingGuideBaseProps &&
                        this.props.pacingGuideBaseProps.hasOwnProperty('state') &&
                        this.props.pacingGuideBaseProps.state) {
                        this.props.pacingGuideBaseProps.setStandardNameAndCategoryFunc(
                            standardName, category
                        )
                        this.getData(standardName, standard, category)
                        clearInterval(baseMountedInterval)
                    }
                }, 100);
            }
        }
    }
    componentWillUnmount() {
        clearTimeout(this.restoreScrollTimeout)
    }
    // Same fuzzy matcher used on the pacing guide: substring hits rank highest,
    // otherwise an in-order subsequence match rewarding consecutive characters.
    fuzzyScore = (query, text) => {
        query = (query || '').toLowerCase().trim()
        text = (text || '').toLowerCase()
        if (!query) return 0
        if (!text) return -1
        const idx = text.indexOf(query)
        if (idx !== -1) {
            return 1000 - idx - (text.length - query.length) * 0.1
        }
        let ti = 0, score = 0, consecutive = 0, prevMatchIdx = -1
        for (let qi = 0; qi < query.length; qi++) {
            const qc = query[qi]
            let found = false
            while (ti < text.length) {
                if (text[ti] === qc) {
                    found = true
                    if (prevMatchIdx !== -1 && prevMatchIdx === ti - 1) {
                        consecutive++
                        score += 5 + consecutive
                    } else {
                        consecutive = 0
                        score += 1
                    }
                    prevMatchIdx = ti
                    ti++
                    break
                }
                ti++
            }
            if (!found) return -1
        }
        return score
    }

    // Flatten the pacing guide into searchable entries carrying week + index so a
    // hit can load the correct lesson plan. Falls back to the flat standards list
    // (no week/index) if the guide hasn't loaded, matching the dropdown's fallback.
    getAllStandards = () => {
        const weeks = this.getPacingGuideWeeks()
        const results = []
        if (weeks.length) {
            weeks.forEach((w) => {
                (w.standards || []).forEach((s) => {
                    results.push({
                        standard: s.standard, title: s.title,
                        week: w.week, quarter: w.quarter, index: s.index,
                        hasWeek: true,
                    })
                })
            })
            return results
        }
        const base = this.props.pacingGuideBaseProps
        if (base && Array.isArray(base.standards)) {
            base.standards.forEach((s) => {
                results.push({ standard: s.standard, title: s.title, hasWeek: false })
            })
        }
        return results
    }

    getSearchResults = () => {
        const query = (this.state.searchQuery || '').trim()
        if (!query) return []
        const scored = []
        this.getAllStandards().forEach((entry) => {
            const score = Math.max(
                this.fuzzyScore(query, entry.standard),
                this.fuzzyScore(query, entry.title)
            )
            if (score > 0) scored.push(Object.assign({}, entry, { score }))
        })
        scored.sort((a, b) => b.score - a.score)
        // one card per standard: after sorting, the first occurrence is the
        // best-scoring one, so keep it and drop later duplicates
        const seen = {}
        const deduped = []
        scored.forEach((r) => {
            if (seen[r.standard]) return
            seen[r.standard] = true
            deduped.push(r)
        })
        return deduped
    }

    // Centralizes the open/close scroll handling. Captured here (before setState)
    // so window.scrollY is still the pre-collapse position when search opens.
    setSearchQuery = (value) => {
        const wasEmpty = !this.state.searchQuery.trim()
        const nowEmpty = !value.trim()
        if (wasEmpty && !nowEmpty) {
            this.savedScrollY = window.scrollY
            this.setState({ searchQuery: value }, () => {
                window.scrollTo({ top: 0, behavior: 'auto' })
            })
        } else if (!wasEmpty && nowEmpty) {
            const targetY = this.savedScrollY || 0
            this.setState({ searchQuery: value }, () => {
                // let the lesson plan lay back out before restoring; behavior:auto
                // overrides any CSS smooth-scroll (which would land short)
                clearTimeout(this.restoreScrollTimeout)
                this.restoreScrollTimeout = setTimeout(() => {
                    window.scrollTo({ top: targetY, behavior: 'auto' })
                }, 60)
            })
        } else {
            this.setState({ searchQuery: value })
        }
    }

    // Clicking a result loads that standard's lesson plan in place (same as the
    // dropdown) and closes search, jumping to the top rather than restoring.
    loadStandardFromSearch = (entry) => {
        if (entry.hasWeek) {
            this.onLessonPlanStandardChangeWeeks(entry.week + '--' + entry.standard + '--' + entry.index)
        } else {
            this.onLessonPlanStandardChange(entry.standard)
        }
        this.setState({ searchQuery: '' }, () => {
            window.scrollTo({ top: 0, behavior: 'auto' })
        })
    }

    renderSearchBar = () => {
        return <div
            className='pacing-guide-search'
            style={{
                position: 'fixed',
                top: 85,
                left: 280,
                right: 0,
                paddingTop: 14,
                paddingBottom: 14,
                paddingLeft: 32,
                paddingRight: 32,
                borderRadius: 0,
                zIndex: 1000,
                background: '#fff',
                boxShadow: '0 6px 12px -6px rgba(15, 23, 42, 0.12)',
            }}>
            <style>{`
            .pacing-guide-search .ant-input-affix-wrapper .ant-input-prefix { left: 20px; }
            .pacing-guide-search .ant-input-affix-wrapper input {
                font-size: 18px !important;
                height: 50px !important;
                padding-left: 50px !important;
                border-radius: 100px !important;
                border: 2px solid #cfe3ff !important;
                background: #f5f9ff !important;
                box-shadow: 0 2px 8px rgba(45, 106, 159, 0.08) !important;
                transition: all 0.15s ease !important;
            }
            .pacing-guide-search .ant-input-affix-wrapper input:hover {
                border-color: #7fb0e0 !important;
                background: #fff !important;
            }
            .pacing-guide-search .ant-input-affix-wrapper input:focus {
                border-color: #2d6a9f !important;
                background: #fff !important;
                box-shadow: 0 0 0 4px rgba(45, 106, 159, 0.15) !important;
            }
            .pacing-guide-search .ant-input-affix-wrapper input::placeholder {
                color: #94a3b8 !important;
                opacity: 1 !important;
            }
        `}</style>
            <Input
                size='large'
                allowClear
                placeholder='Search by standard or standard description...'
                value={this.state.searchQuery}
                onChange={(e) => this.setSearchQuery(e.target.value)}
                prefix={<Icon type='search' style={{ color: '#7fb0e0', fontSize: 20 }} />}
            />
        </div>
    }

    renderSearchResultCard = (r) => {
        const isCurrent = r.standard === this.state.standard
        return <div
            key={'search-' + r.standard + '-' + (r.index != null ? r.index : '') + '-q' + (r.quarter || '')}
            style={{
                background: '#fff', border: isCurrent ? '2px solid #3b82f6' : '1px solid #e8eef5',
                borderRadius: 16, padding: '18px 20px', marginBottom: 14,
                boxShadow: 'rgba(100, 100, 111, 0.12) 0px 4px 14px 0px',
            }}>
            {r.hasWeek ?
                <div style={{ fontSize: 13, fontWeight: 700, color: '#2d6a9f', letterSpacing: 0.4, textTransform: 'uppercase', marginBottom: 6 }}>
                    Quarter {r.quarter}, Week {r.week}
                </div> : ''}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b' }}>{r.standard}</div>
                {isCurrent ?
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#eff6ff', color: '#2563eb', borderRadius: 999, padding: '4px 12px', fontSize: 14, fontWeight: 700, border: '1px solid #bfdbfe' }}>Currently viewing</span>
                    : ''}
            </div>
            <div style={{ fontSize: 17, color: '#334155', lineHeight: 1.5 }}>{r.title}</div>
            <div
                onClick={() => this.loadStandardFromSearch(r)}
                className='ant-btn ant-btn-lg ant-btn-primary flex flex-v-center flex-h-center font-18 font-bold'
                style={{ width: '100%', height: 'auto', padding: '12px 16px', marginTop: 14, cursor: 'pointer' }}>
                <Icon type='solution' className='mr-1 font-24' />
                <span>Click here to view the lesson</span>
            </div>
        </div>
    }

    renderSearchResults = () => {
        const results = this.getSearchResults()
        return <div className='mt-2'>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: 20, flexWrap: 'wrap' }}>
                <div style={{ fontSize: 24, fontWeight: 800, color: '#1e293b' }}>
                    {results.length} {results.length === 1 ? 'result' : 'results'} for &ldquo;{this.state.searchQuery.trim()}&rdquo;
                </div>
                <Button
                    size='large'
                    type='primary'
                    onClick={() => this.setSearchQuery('')}
                    style={{ height: 'auto', padding: '12px 22px', fontSize: 17, fontWeight: 700, borderRadius: 12, display: 'inline-flex', alignItems: 'center', gap: 8 }}
                >
                    <Icon type='close' className='font-20' />
                    <span>Close search &amp; return to lesson</span>
                </Button>
            </div>
            {results.length === 0 ?
                <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <Icon type='search' style={{ fontSize: 48, color: '#cbd5e1' }} />
                    <div style={{ fontSize: 20, fontWeight: 700, color: '#475569', marginTop: 16 }}>No standards found</div>
                    <div style={{ fontSize: 16, color: '#94a3b8', marginTop: 6 }}>Try a different code or keyword.</div>
                </div>
                :
                results.map((r) => this.renderSearchResultCard(r))}
        </div>
    }
    componentWillReceiveProps(nextProps) {
        /*let standardName = getQueryStringParam('standardName')
        let standard = getQueryStringParam('standard')
        let category = getQueryStringParam('category')
        this.getData(standardName, standard, category)*/
    }
    getData = (standardName, standard, category) => {
        if (!(this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.hasOwnProperty('state') &&
            this.props.pacingGuideBaseProps.state &&
            this.props.teacherBaseProps &&
            this.props.teacherBaseProps.district &&
            standardName &&
            category)) {
            return
        }
        // already have this data
        if (standardName === this.state.standardName &&
            standard === this.state.standard &&
            category === this.state.category) {
            return
        }
        //console.log('getData')
        this.setState({
            standardName: standardName,
            standard: standard,
            selectStandard: standard,
            category: category,
        })
        let state = this.props.pacingGuideBaseProps.state
        // demo is NY, fix later
        if (state === 'NY') {
            state = 'SC'
        }
        // KY ELA standards are 9-10 and 11-12
        if (state === 'KY' && category === 'ELA') {
            if (standardName === '10th Grade') {
                standardName = '9th Grade'
            } else if (standardName === '12th Grade') {
                standardName = '11th Grade'
            }
        }
        let lessonPlanVersion = '2.0';
        db.collection(ColType.studentResources)
            .where('state', '==', state)
            .where('standard.standardName', '==', standardName)
            .where('standard.standardCategory', '==', category)
            .where('standard.standard', '==', standard)
            .where('version', '==', '3.0')
            .orderBy('createdAt', 'desc')
            .limit(1)
            .get()
            .then((querySnapshot) => {
                // console.log('studentResource empty', querySnapshot.empty)
                if (!querySnapshot.empty) {
                    const doc = querySnapshot.docs[0]
                    let studentResource = flattenDoc(doc)
                    studentResource.doc = injectBaseHref(studentResource.doc)
                    // console.log('studentResource', studentResource)
                    this.setState({
                        studentResource: studentResource,
                    })
                } else {
                    this.setState({
                        studentResource: null,
                    })
                }
            })
            .catch((error) => {
                console.log('Error getting student resource:', error);
            });
        db.collection(ColType.lessonPlans)
            .where('state', '==', state)
            .where('standard.standardName', '==', standardName)
            .where('standard.standardCategory', '==', category)
            .where('standard.standard', '==', standard)
            .where('version', '==', lessonPlanVersion)
            .limit(1)
            .get()
            .then((querySnapshot) => {
                // console.log(querySnapshot.docs);
                if (!querySnapshot.empty) {
                    const doc = querySnapshot.docs[0]
                    let lessonPlan = flattenDoc(doc)
                    //console.log(lessonPlan)
                    lessonPlan.doc = JSON.parse(lessonPlan.doc)
                    //console.log(lessonPlan)
                    //this.getFileURLDict(lessonPlan)
                    // try to parse out DOK Levels
                    let dokLevelDocs = []
                    let lessonPlanDocs = []
                    let mode = 'lessonPlan'
                    // filter out any H1 types
                    lessonPlan.doc.components = lessonPlan.doc.components.filter((doc) => {
                        if (doc && doc.type && doc.type === 'H1') {
                            return false
                        }
                        return true
                    });
                    lessonPlan.doc.components.map((doc) => {
                        let heading = '';
                        if ((doc.hasOwnProperty('content') &&
                            (doc.content === 'DOK Levels' || doc.content === 'DOK Differentiation')) ||
                            (doc.hasOwnProperty('heading') &&
                                (doc.heading === 'DOK Levels' || doc.heading === 'DOK Differentiation'))) {
                            mode = 'dokLevels'
                            // edit to make it an h1
                            doc.type = 'H1'
                            doc.heading = 'DOK Differentiation'
                            doc.content = 'DOK Differentiation'
                        } else if (mode === 'dokLevels' &&
                            ((doc.hasOwnProperty('content') &&
                                doc.content === 'Assessment') ||
                                (doc.hasOwnProperty('heading') &&
                                    doc.heading === 'Assessment'))) {
                            mode = 'lessonPlan'
                        }
                        if (mode === 'dokLevels' && doc.type === 'H3') {
                            doc.type = 'H2'
                        }
                        if (mode === 'lessonPlan') {
                            lessonPlanDocs.push(doc)
                        } else {
                            dokLevelDocs.push(doc)
                        }
                        return false
                    })
                    if (dokLevelDocs.length > 0) {
                        lessonPlan.dokLevelDocs = dokLevelDocs
                        lessonPlan.lessonPlanDocs = lessonPlanDocs
                        //lessonPlan.printDOKLevelDocs = DOKHeadingDocs.concat(standardPDFPrintDocs).concat(dokLevelDocs)
                        //lessonPlan.printLessonPlanDocs = lessonPlanHeadingDocs.concat(standardPDFPrintDocs).concat(lessonPlanDocs)
                    } else {
                        //lessonPlan.printLessonPlanDocs = lessonPlanHeadingDocs.concat(standardPDFPrintDocs).concat(lessonPlanDocs)
                    }
                    this.setState({
                        lessonPlan: lessonPlan,
                        lessonPlanFound: true,
                    })
                    //console.log('lessonPlan', lessonPlan)
                } else {
                    //console.log('lessonPlan doc does not exist')
                    this.setState({
                        lessonPlan: null,
                        lessonPlanFound: false,
                    })
                }
            })
        db.collection(ColType.quizzes)
            .where('standardName', '==', standardName)
            .where('standardCategory', '==', category)
            .where('standards', 'array-contains', standard)
            .where('assessmentCategory', '==', 'quiz')
            .where('state', '==', state)
            .where('year', '==', '2025')
            .where('districtId', '==', '__all__')
            .where('live', '==', true)
            .orderBy("createdAt", "asc")
            .get()
            .then((querySnapshot) => {
                let quizzes = []
                querySnapshot.forEach((doc) => {
                    let quiz = flattenDoc(doc)
                    if (quiz.hasOwnProperty('version') && quiz.version === '4.0') {
                        quizzes.push(quiz)
                    }
                })
                this.setState({
                    quizzes: quizzes,
                })
                console.log('(Quiz) quizzes', quizzes)
            })
    }
    downloadFile = (downloadURL) => {
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest()
            xhr.responseType = 'blob'
            xhr.onload = (event) => {
                var blob = xhr.response
                //console.log('blob', blob)
                resolve(blob)
            }
            xhr.onerror = (event) => {
                console.error('error')
                reject()
            }
            xhr.open('GET', downloadURL)
            xhr.send()
        })
    }
    onLessonPlanStandardChange = (value) => {
        this.getData(this.state.standardName, value, this.state.category)
    }
    onLessonPlanStandardChangeWeeks = (pValue) => {
        // split on ('--')
        let value = pValue.split('--')
        if (value.length !== 3) {
            return
        }
        const standardValue = value[1]
        if (!standardValue) {
            return
        }
        this.setState({
            selectWeek: value[0],
            selectStandard: standardValue,
            selectIdx: value[2],
        })
        this.getData(this.state.standardName, standardValue, this.state.category)
    }
    getFileURLDict = (lessonPlan) => {
        this.setState({ fileURLDict: {} })
    }
    // Build the "View other standards" dropdown to mirror the pacing guide in
    // PacingGuideSC: Quarter 1 Week 1 ... Quarter 4 Week 9. Reads the same
    // pacingGuideBaseProps.pacingGuide.weeks (keyed by absolute week number) and
    // weekNums it iterates, computing quarter = ceil(ind / 9) and the per-quarter
    // week = ind % 9 (0 -> 9), exactly as that component does.
    // Returns [{ quarter, week, standards: [{ standard, title, index }, ...] }, ...].
    getPacingGuideWeeks = () => {
        const base = this.props.pacingGuideBaseProps
        if (!base || !Array.isArray(base.weekNums)) {
            return []
        }
        // Use the future pacing guide when previewing next year's standards.
        const guide = (base.pacingGuideMode === 'future' && base.futurePacingGuide) ?
            base.futurePacingGuide : base.pacingGuide
        if (!guide || !guide.weeks) {
            return []
        }
        let weeks = []
        base.weekNums.forEach((weekNumber, ind) => {
            // weekNums[0] is a placeholder (skipped in PacingGuideSC)
            if (ind === 0) {
                return
            }
            if (!guide.weeks.hasOwnProperty(weekNumber)) {
                return
            }
            const week = guide.weeks[weekNumber]
            if (!week) {
                return
            }
            const quarter = Math.ceil(ind / 9)
            let weekNumForQuarter = ind % 9
            if (weekNumForQuarter === 0) {
                weekNumForQuarter = 9
            }
            weeks.push({
                quarter: quarter,
                week: weekNumForQuarter,
                standards: week.map((item, index) => ({
                    standard: item.standard,
                    title: item.title,
                    // index within the week, matching the lesson-plan link's
                    // `index` query param in PacingGuideSC
                    index: index,
                })),
            })
        })
        return weeks
    }
    startQuiz = (assessmentDocs) => {
        if (!this.props.teacherBaseProps.teacher) {
            //console.log('startQuiz - teacher is null')
            return
        }
        if (!(this.state.lessonPlan &&
            this.state.lessonPlan.standard &&
            this.state.lessonPlan.standard.standard &&
            this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.standardsDict &&
            this.props.pacingGuideBaseProps.standardsDict.hasOwnProperty(this.state.lessonPlan.standard.standard) &&
            this.props.pacingGuideBaseProps.standardsDict[this.state.lessonPlan.standard.standard])) {
            //console.log('could not find pacing guide standard')
            return
        }
        let studentsWithCleverIds = []
        if (this.props.teacherBaseProps &&
            this.props.teacherBaseProps.students) {
            studentsWithCleverIds = this.props.teacherBaseProps.students.filter((student) => {
                return student.hasOwnProperty('cleverId') && student.cleverId
            })
        }
        if (studentsWithCleverIds.length === 0) {
            //console.log('startQuiz - no students with cleverIds')
            notification.open({
                type: 'error',
                duration: 4,
                message: 'You currently have no students from Clever. Please sync your students from Clever and try again.',
                placement: 'bottomRight'
            })
            return
        }
        this.setState({
            startingQuiz: true,
        })
        cleverStartQuiz(this.props.teacherBaseProps.teacher, studentsWithCleverIds, assessmentDocs,
            this.props.pacingGuideBaseProps.standardsDict[this.state.lessonPlan.standard.standard])
            .then((result) => {
                if (result.hasOwnProperty('message') &&
                    result.message === 'Error during assessment creation') {
                    notification.open({
                        type: 'error',
                        duration: 4,
                        message: 'An error occurred while starting the quiz. Please try again.',
                        placement: 'bottomRight'
                    })
                } else {
                    notification.open({
                        type: 'success',
                        duration: 4,
                        message: 'Quiz started successfully',
                        placement: 'bottomRight'
                    })
                }
                this.setState({
                    startingQuiz: false,
                })
            })
            .catch(() => {
                notification.open({
                    type: 'error',
                    duration: 4,
                    message: 'An error occurred while starting the quiz. Please try again.',
                    placement: 'bottomRight'
                })
                this.setState({
                    startingQuiz: false,
                })
            })
    }


    // Friendly "how this page works" overview, shown at the top so a teacher
    // can see the whole flow at a glance before diving into any one section.
    renderHelpBanner = (stepTabs) => {
        return <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', background: '#f0f7ff', border: '1px solid #cfe3ff', borderRadius: 16, padding: '18px 22px', marginBottom: 22 }}>
            <Icon type='compass' style={{ fontSize: 34, color: '#2d6a9f', marginTop: 2 }} />
            <div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 4 }}>How this page works</div>
                <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.6 }}>
                    Everything for this standard is in the menu on the left, listed in order.
                    Just go top to bottom. <b>Step 1</b> is the full lesson plan you can read or copy.
                    <b> Step 2</b> is the same lesson as slides you can present.
                    <b> Step 3</b> is games your students can play any time for extra practice &mdash; there's nothing to assign.
                    <b> Step 4</b> is practice your students can do on their own &mdash; you don't have to assign it.
                    <b> Step 5</b> is a quiz that you assign when you're ready to check how they're doing.
                    Your <b>district resources</b> are at the bottom.
                </div>
            </div>
        </div>
    }
    // The plain-language intro shown at the top of whichever section is open,
    // so a teacher always knows what they're looking at and what to do next.
    renderStepIntro = (tab) => {
        if (!tab || !tab.description) {
            return ''
        }
        return <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', background: '#fff', border: '1px solid #e8eef5', borderRadius: 16, padding: '18px 22px', marginBottom: 20, boxShadow: 'rgba(100, 100, 111, 0.10) 0px 4px 14px 0px' }}>
            <div style={{ flex: '0 0 auto', width: 50, height: 50, borderRadius: 12, background: '#2d6a9f', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: tab.step ? 24 : 22, fontWeight: 800 }}>
                {tab.step ? tab.step : <Icon type={tab.icon} style={{ fontSize: 24 }} />}
            </div>
            <div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', marginBottom: 4 }}>
                    {tab.step ? 'Step ' + tab.step + ': ' : ''}{tab.label}
                </div>
                <div style={{ fontSize: 16, color: '#475569', lineHeight: 1.6 }}>{tab.description}</div>
            </div>
        </div>
    }
    // A single left-menu item. Numbered "step" items show a small Step label
    // above the name; everything else just shows the name.
    renderMenuItem = (t, activeKey) => {
        const isActive = t.key === activeKey
        return <div key={t.key}
            onClick={() => this.setState({ activeTab: t.key })}
            className='flex flex-v-center'
            style={{
                cursor: 'pointer',
                padding: '12px 14px',
                borderRadius: 12,
                marginBottom: 6,
                backgroundColor: isActive ? '#eff6ff' : 'transparent',
                color: isActive ? '#1e40af' : '#475569',
                transition: 'all 0.15s ease',
            }}>
            <div className='flex flex-v-center flex-h-center' style={{
                width: 34, height: 34, borderRadius: 9,
                backgroundColor: isActive ? '#2d6a9f' : '#f0f2f5',
                color: isActive ? '#fff' : '#475569',
                marginRight: 12, flex: '0 0 34px',
            }}>
                {t.step ?
                    <span style={{ fontSize: 16, fontWeight: 800 }}>{t.step}</span>
                    : <Icon type={t.icon} style={{ fontSize: 16 }} />}
            </div>
            <div>
                {t.step ?
                    <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', color: isActive ? '#2563eb' : '#94a3b8' }}>
                        Step {t.step}
                    </div>
                    : ''}
                <div style={{ fontSize: 16, fontWeight: isActive ? 700 : 500, lineHeight: 1.2 }}>{t.label}</div>
            </div>
        </div>
    }
    render() {
        const linkBack = this.state.fromWeeklyPlanner ? 'weekly-planner' : 'guide'
        const linkBackText = this.state.fromWeeklyPlanner ? 'Weekly Planner' : 'Pacing Guide & Lessons'
        const componentContainerClassName = 'w-100'
        let person = null
        if (this.props.teacherBaseProps) {
            if (this.props.teacherBaseProps.teacher) {
                person = this.props.teacherBaseProps.teacher
            } else if (this.props.teacherBaseProps.admin) {
                person = this.props.teacherBaseProps.admin
            } else if (this.props.teacherBaseProps.schoolAdmin) {
                person = this.props.teacherBaseProps.schoolAdmin
            } else if (this.props.teacherBaseProps.instructionalFacilitator) {
                person = this.props.teacherBaseProps.instructionalFacilitator
            }
        }
        // Only show the lesson slides for SC districts for now.
        const districtState = (this.props.teacherBaseProps &&
            this.props.teacherBaseProps.district &&
            this.props.teacherBaseProps.district.state) ? this.props.teacherBaseProps.district.state : ''
        const showSlides = true;
        const lp = this.state.lessonPlan
        const pacingGuideWeeks = this.getPacingGuideWeeks()
        const hasDokSplit = !!(lp && lp.dokLevelDocs && lp.dokLevelDocs.length > 0 &&
            lp.lessonPlanDocs && lp.lessonPlanDocs.length > 0)
        const hasLessonComponents = !!(lp && lp.doc && lp.doc.components)
        const quizTabAvailable = !!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.district &&
            this.state.quizzes.length > 0 &&
            this.state.standardName !== '')
        let isPriority = false
        if (lp && lp.standard && lp.standard.standard &&
            this.props.pacingGuideBaseProps &&
            this.props.pacingGuideBaseProps.standardsDict &&
            this.props.pacingGuideBaseProps.standardsDict.hasOwnProperty(lp.standard.standard) &&
            this.props.pacingGuideBaseProps.standardsDict[lp.standard.standard] &&
            this.props.pacingGuideBaseProps.standardsDict[lp.standard.standard].isPriority) {
            isPriority = true
        }
        // Build the left-menu sections. The first four (when available) are the
        // numbered "do this in order" steps; the rest are anytime resources.
        // Step numbers are assigned in sequence so there are never any gaps
        // (e.g. if there's no Student Practice, Quizzes simply renumbers).
        let tabs = []
        let stepCounter = 0
        const addStep = (tab) => {
            stepCounter += 1
            tab.step = String(stepCounter)
            tabs.push(tab)
        }
        if (lp) {
            // ---- Numbered steps (do these in order) ----
            if (showSlides && hasLessonComponents) {
                // Step 1 — the full lesson plan in a readable, copy/paste form.
                addStep({
                    key: 'lesson-plan-copy-tab',
                    label: 'Full Lesson Plan',
                    icon: 'file-text',
                    description: <span>
                        The complete, ready-to-teach lesson for this standard. Read through the
                        whole thing here, or use <b>"Copy lesson plan"</b> to copy it as plain
                        text. This is the place to start.
                    </span>,
                })
                // Step 2 — the same lesson plan as a slide deck you can present.
                addStep({
                    key: 'lesson-plan-slides-tab',
                    label: 'Lesson Plan Slides',
                    icon: 'read',
                    description: <span>
                        The same lesson plan, broken into slides you can click through one at a
                        time or <b>present full screen</b> on the board for your class.
                    </span>,
                })
            }
            addStep({
                key: 'games-tab',
                label: 'Games',
                icon: 'trophy',
                description: <span>
                    Games can be played any time to practice this standard. There's nothing to
                    assign &mdash; feel free to use them whenever you'd like for extra practice.
                </span>,
            })
            if (this.state.studentResource) {
                addStep({
                    key: 'resource-tab',
                    label: 'Student Practice',
                    icon: 'profile',
                    description: <span>
                        Once you've taught the lesson, you can <b>work through this practice together
                            as a class</b> &mdash; use <b>"Present full screen"</b> below to put it up on
                        the board &mdash; or have your <b>students work on it on their own</b>. Either
                        way, students just sign in to their account to work on it, and there's
                        nothing for you to assign.
                    </span>,
                })
            }
            if (quizTabAvailable) {
                addStep({
                    key: 'quiz-tab',
                    label: 'Quizzes',
                    icon: 'form',
                    description: <span>
                        When you want to check how your students are doing, give them a quiz.
                        Unlike the practice above, <b>a quiz does have to be assigned by you</b>
                        {' '}before your students can take it. Use the button below to assign one.
                    </span>,
                })
            }
            // ---- Anytime resources (use whenever you'd like) ----

            if (hasDokSplit) {
                tabs.push({
                    key: 'dok-differentiation-tab',
                    label: 'DOK Differentiation',
                    icon: 'cluster',
                    description: <span>
                        Extra activities at different levels of difficulty. Use these to give more
                        support to students who need it, or an added challenge to students who are ready.
                    </span>,
                })
            }
            tabs.push({
                key: 'district-resources-tab',
                label: 'District Resources',
                icon: 'folder',
                description: <span>
                    Any files and materials your district has shared for this standard. They'll
                    be here at the bottom whenever you need them.
                </span>,
            })
        }
        const stepTabs = tabs.filter((t) => t.step)
        const extraTabs = tabs.filter((t) => !t.step)
        // Default to the first numbered step if available, otherwise the first section.
        let activeKey = this.state.activeTab
        if (!activeKey || !tabs.find((t) => t.key === activeKey)) {
            if (tabs.find((t) => t.key === 'lesson-plan-copy-tab')) {
                activeKey = 'lesson-plan-copy-tab'
            } else if (tabs.length) {
                activeKey = tabs[0].key
            } else {
                activeKey = ''
            }
        }
        const activeTabObj = tabs.find((t) => t.key === activeKey)
        const bannerChip = {
            display: 'inline-flex', alignItems: 'center', background: 'rgba(255,255,255,0.18)',
            color: '#fff', borderRadius: 999, padding: '4px 14px', fontSize: 16, fontWeight: 600, marginRight: 8
        }
        return (
            <div>
                {this.props.teacherBaseProps ?
                    <Layout className="layout-header-mt mt-0 min-w-1024">
                        <Sider
                            width={280}
                            style={{
                                overflow: 'auto', overflowX: 'hidden', height: 'calc(100% - 82px)',
                                position: 'fixed',
                                left: 0, marginTop: '82px', borderRight: '1px solid #f1f1f1',
                                background: '#fff', borderTop: '1px solid #f1f1f1', fontSize: 16
                            }}>
                            <div className='pl-2 pr-2 mt-3'>
                                <div className='mb-2 font-16'>
                                    {this.props.teacherBaseProps.teacher ?
                                        <Link to={'/teacher/pacing-guide/' + linkBack + '/' + this.props.teacherBaseProps.teacher.id}
                                            className='inline-flex flex-v-center'>
                                            <Icon type='arrow-left' className='mr-1' />{linkBackText}
                                        </Link>
                                        : ''}
                                    {this.props.teacherBaseProps.admin ?
                                        <Link to={'/admin/pacing-guide/' + linkBack + '/' + this.props.teacherBaseProps.admin.id}
                                            className='inline-flex flex-v-center'>
                                            <Icon type='arrow-left' className='mr-1' />{linkBackText}
                                        </Link>
                                        : ''}
                                    {this.props.teacherBaseProps.instructionalFacilitator ?
                                        <Link to={'/instructional-facilitator/pacing-guide/' + linkBack + '/' + this.props.teacherBaseProps.instructionalFacilitator.id}
                                            className='inline-flex flex-v-center'>
                                            <Icon type='arrow-left' className='mr-1' />{linkBackText}
                                        </Link>
                                        : ''}
                                    {this.props.teacherBaseProps.schoolAdmin ?
                                        <Link to={'/school-admin/pacing-guide/' + linkBack + '/' + this.props.teacherBaseProps.schoolAdmin.id}
                                            className='inline-flex flex-v-center'>
                                            <Icon type='arrow-left' className='mr-1' />{linkBackText}
                                        </Link>
                                        : ''}
                                </div>
                                <div className='font-14 mb-1' style={{ color: '#8c98a8' }}>View other standards</div>
                                <select
                                    className='w-100 mb-2'
                                    style={{ height: 40, fontSize: 16 }}   // roughly matches antd size="large"
                                    value={pacingGuideWeeks.length ?
                                        (this.state.selectWeek + '--' + this.state.selectStandard + '--' + this.state.selectIdx)
                                        : this.state.standard}
                                    onChange={(e) => {
                                        const val = e.target.value
                                        if (pacingGuideWeeks.length) {
                                            this.onLessonPlanStandardChangeWeeks(val)
                                        } else {
                                            this.onLessonPlanStandardChange(val)
                                        }
                                    }}>
                                    {pacingGuideWeeks.length ?
                                        pacingGuideWeeks.map((weekEntry) => (
                                            <optgroup key={'q' + weekEntry.quarter + '-w' + weekEntry.week}
                                                label={'Quarter ' + weekEntry.quarter + ', Week ' + weekEntry.week}>
                                                {(weekEntry.standards || []).map((standard) => {
                                                    const optionValue = weekEntry.week + '--' + standard.standard + '--' + standard.index
                                                    return <option key={'q' + weekEntry.quarter + '-w' + weekEntry.week + '-' + standard.standard + '-' + standard.index} value={optionValue}>
                                                        {'Week ' + weekEntry.week + ', Quarter ' + weekEntry.quarter + ' - ' + standard.standard}
                                                    </option>
                                                })}
                                            </optgroup>
                                        ))
                                        :
                                        (this.props.pacingGuideBaseProps &&
                                            this.props.pacingGuideBaseProps.standards.map((standard) => (
                                                <option key={standard.standard} value={standard.standard}>{standard.standard}</option>
                                            )))}
                                </select>
                            </div>
                            <div className='pl-2 pr-2 mt-2'>
                                {stepTabs.length > 0 ?
                                    <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', color: '#94a3b8', padding: '4px 14px 8px' }}>
                                        Follow these in order
                                    </div>
                                    : ''}
                                {stepTabs.map((t) => this.renderMenuItem(t, activeKey))}
                                {extraTabs.length > 0 ?
                                    <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: 'uppercase', color: '#94a3b8', padding: '16px 14px 8px' }}>
                                        Additional resources
                                    </div>
                                    : ''}
                                {extraTabs.map((t) => this.renderMenuItem(t, activeKey))}
                            </div>
                        </Sider>
                        <Layout className="content">
                            <Content
                                style={{
                                    marginLeft: 280, marginTop: '154px',
                                    overflowX: 'initial', paddingTop: 80
                                }}
                                className='p-2 pl-4 pr-4'>
                                {this.renderSearchBar()}
                                {this.state.searchQuery.trim() ?
                                    this.renderSearchResults()
                                    :
                                    <div>
                                        <div className='mt-2 mb-4'>
                                            <div className='br-20 p-3'
                                                style={{ minHeight: '200px', background: 'linear-gradient(135deg, #1e3a5f 0%, #2d6a9f 100%)' }}>
                                                <div className='h-100'>
                                                    <div className='flex flex-v-center font-40 font-fff w-100 h-100 p-4'>
                                                        <div className='w-100'>
                                                            <div className='font-40 font-bold font-fff'>{this.state.standardName}</div>
                                                            <div className='font-24 font-fff'>{'Standard: ' + this.state.standard}</div>
                                                            <div className='font-20 font-fff mt-1'>{lp && lp.standard ? lp.standard.title : ''}</div>
                                                            {lp && lp.standard ?
                                                                <div className='mt-2'>
                                                                    {lp.standard.standardCategory ?
                                                                        <span style={bannerChip}>{lp.standard.standardCategory}</span> : ''}
                                                                    {lp.standard.grade ?
                                                                        <span style={bannerChip}>{'Grade: ' + lp.standard.grade}</span> : ''}
                                                                    {isPriority ?
                                                                        <span style={{ ...bannerChip, background: '#fff', color: '#722ed1' }}>
                                                                            <Icon type='pushpin' className='mr-1' />Priority Standard
                                                                        </span> : ''}
                                                                </div>
                                                                : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {!this.state.lessonPlanFound ?
                                            <div className='background-fff p-4 br-15 ant-shadow'>
                                                <div className='flex flex-v-center'>
                                                    <Icon type='clock-circle' style={{ fontSize: 28, color: '#2d6a9f' }} className='mr-2' />
                                                    <div className='font-24'>This lesson plan is coming soon.</div>
                                                </div>
                                            </div>
                                            : ''}
                                        {lp ?
                                            <div className='mt-2'>
                                                {this.renderHelpBanner(stepTabs)}
                                                {this.renderStepIntro(activeTabObj)}
                                                {activeKey === 'lesson-plan-copy-tab' && showSlides && hasLessonComponents ?
                                                    <div className='mb-100'>
                                                        <LessonPlanSlides
                                                            mode='copy'
                                                            components={hasDokSplit ? lp.lessonPlanDocs : lp.doc.components}
                                                        />
                                                    </div>
                                                    : ''}
                                                {activeKey === 'lesson-plan-slides-tab' && showSlides && hasLessonComponents ?
                                                    <div className='mb-100'>
                                                        <LessonPlanSlides
                                                            mode='slides'
                                                            components={hasDokSplit ? lp.lessonPlanDocs : lp.doc.components}
                                                        />
                                                    </div>
                                                    : ''}
                                                {activeKey === 'dok-differentiation-tab' && hasDokSplit ?
                                                    <div className={'background-fff p-4 br-15 mb-100 ant-shadow ' + componentContainerClassName + ' edviz-list-style-none'}>
                                                        <DocumentDelegator
                                                            document={{
                                                                components: lp.dokLevelDocs,
                                                                metadata: { 'edvizVersion': '2' }
                                                            }}
                                                        />
                                                    </div>
                                                    : ''}
                                                {activeKey === 'resource-tab' && this.state.studentResource ?
                                                    <div style={{ minHeight: '1800px' }}>

                                                        {this.props.teacherBaseProps &&
                                                            this.props.teacherBaseProps.district &&
                                                            this.state.standard &&
                                                            this.state.category &&
                                                            person ?
                                                            <StudentPracticePresenter
                                                                key={'practice-' + this.state.studentResource.id}
                                                                studentResource={this.state.studentResource} />
                                                            : ''}
                                                    </div>
                                                    : ''}
                                                {activeKey === 'district-resources-tab' ?
                                                    <div className={'background-fff p-4 br-15 mb-100 ant-shadow ' + componentContainerClassName}>
                                                        {this.props.teacherBaseProps &&
                                                            this.props.teacherBaseProps.district &&
                                                            this.state.standard &&
                                                            this.state.category &&
                                                            person ?
                                                            <PacingGuideUploads
                                                                districtId={this.props.teacherBaseProps.district.id}
                                                                standard={this.state.standard}
                                                                standardCategory={this.state.category}
                                                                personId={person.id}
                                                            /> : ''}
                                                    </div>
                                                    : ''}
                                                {activeKey === 'games-tab' ?
                                                    <div className={'background-fff p-4 br-15 mb-100 ant-shadow ' + componentContainerClassName}>
                                                        {this.props.teacherBaseProps &&
                                                            this.props.teacherBaseProps.district &&
                                                            this.state.standard &&
                                                            this.state.category &&
                                                            this.state.standardName &&
                                                            person ?
                                                            <div>
                                                                <div className='font-24 font-bold mb-3'>Play Games for this Standard</div>
                                                                {(() => {
                                                                    // The Games component reads these params to build its
                                                                    // "back to the pacing guide" link, so pass them for
                                                                    // every role (not just teacher).
                                                                    const gamesQueryString = '?standardName=' + this.state.standardName +
                                                                        '&standardCategory=' + this.state.category +
                                                                        '&standard=' + this.state.standard +
                                                                        '&week=' + this.state.selectWeek +
                                                                        '&index=' + this.state.selectIdx
                                                                    const gamesLink = this.props.teacherBaseProps &&
                                                                        this.props.teacherBaseProps.teacher ?
                                                                        '/teacher/pacing-guide/games/' + this.props.teacherBaseProps.teacher.id + gamesQueryString
                                                                        :
                                                                        this.props.teacherBaseProps &&
                                                                            this.props.teacherBaseProps.admin ?
                                                                            '/admin/pacing-guide/games/' + this.props.teacherBaseProps.admin.id + gamesQueryString
                                                                            :
                                                                            this.props.teacherBaseProps &&
                                                                                this.props.teacherBaseProps.instructionalFacilitator ?
                                                                                '/instructional-facilitator/pacing-guide/games/' + this.props.teacherBaseProps.instructionalFacilitator.id + gamesQueryString
                                                                                :
                                                                                this.props.teacherBaseProps &&
                                                                                    this.props.teacherBaseProps.schoolAdmin ?
                                                                                    '/school-admin/pacing-guide/games/' + this.props.teacherBaseProps.schoolAdmin.id + gamesQueryString
                                                                                    :
                                                                                    ''
                                                                    return <Link to={gamesLink}
                                                                        size='large'
                                                                        className={'ant-btn lg-btn ant-btn-primary font-20'} style={{ 'display': 'table' }}>
                                                                        <Icon type='trophy' className='mr-05 font-20' />
                                                                        <span>Play Games</span>
                                                                    </Link>
                                                                })()}
                                                            </div>
                                                            : ''}
                                                    </div>
                                                    : ''}
                                                {activeKey === 'quiz-tab' && quizTabAvailable ?
                                                    <div className={componentContainerClassName}
                                                        style={{ minHeight: '1800px' }}>
                                                        <div className='flex flex-v-center w-100'>
                                                            <div className='edviz-document-v2-heading-1'>Quizzes</div>
                                                        </div>
                                                        <div>
                                                            <Tabs defaultActiveKey="quiz-0" animated={false}>
                                                                {this.state.quizzes.map((assessment, idx) => {
                                                                    let quizKey = 'quiz' + idx;
                                                                    let disableQuiz = false
                                                                    if (this.state.lessonPlan &&
                                                                        (this.state.disabledQuizzesDict.hasOwnProperty(this.state.lessonPlan.standard.standard) ||
                                                                            this.state.lessonPlan.standard.standardName === 'Kindergarten' ||
                                                                            this.state.lessonPlan.standard.standardName === '1st Grade')) {
                                                                        //disableQuiz = true
                                                                    }
                                                                    let isKindergartenOrFirstGrade = false
                                                                    if (this.state.lessonPlan &&
                                                                        (this.state.lessonPlan.standard.standardName === 'Kindergarten' ||
                                                                            this.state.lessonPlan.standard.standardName === '1st Grade')) {
                                                                        isKindergartenOrFirstGrade = true
                                                                    }
                                                                    return <Tabs.TabPane tab={<div className='font-20'>{'Quiz #' + (idx + 1)}</div>} key={'quiz-' + idx} className='font-black'>
                                                                        <div className='pt-1'>
                                                                            {this.state.lessonPlan &&
                                                                                this.state.disabledQuizzesDict.hasOwnProperty(this.state.lessonPlan.standard.standard) ?
                                                                                <div className='font-20 mb-05'>This quiz is currently under development and will be available soon.</div>
                                                                                : ''}
                                                                            <div className='flex flex-v-center w-100 mt-2 mb-1'>
                                                                                {this.props.teacherBaseProps &&
                                                                                    this.props.teacherBaseProps.teacher ?
                                                                                    <PacingGuideAssessmentModalForm
                                                                                        assessment={assessment}
                                                                                        teacherBaseProps={this.props.teacherBaseProps}
                                                                                        disableQuiz={disableQuiz}
                                                                                        history={this.props.history}
                                                                                    />
                                                                                    : ''}
                                                                                <ReactToPrint
                                                                                    trigger={() =>
                                                                                        <Button
                                                                                            size={'large'}
                                                                                            type='primary'
                                                                                            className="lg-btn ml-2"
                                                                                        >
                                                                                            <Icon type="printer" />
                                                                                            Print Quiz
                                                                                        </Button>
                                                                                    }
                                                                                    content={() => this.quizComponentRefs[quizKey]}
                                                                                    onBeforeGetContent={() => new Promise((resolve) => {
                                                                                        // switch this quiz to the non-split view before the print content is captured
                                                                                        this.setState({ printingQuizKey: quizKey }, () => {
                                                                                            // give StudentResource a moment to re-render its HTML
                                                                                            setTimeout(resolve, 150)
                                                                                        })
                                                                                    })}
                                                                                    onAfterPrint={() => this.setState({ printingQuizKey: null })}
                                                                                    onPrintError={() => this.setState({ printingQuizKey: null })}
                                                                                />
                                                                                <Checkbox
                                                                                    className='checkbox-lg ml-2 inline-flex flex-v-center'
                                                                                    checked={this.state.answersVisible.hasOwnProperty(quizKey) && this.state.answersVisible[quizKey]}
                                                                                    onClick={(e) => {
                                                                                        let answersVisible = this.state.answersVisible
                                                                                        answersVisible[quizKey] = !(this.state.answersVisible.hasOwnProperty(quizKey) && this.state.answersVisible[quizKey])
                                                                                        this.setState({
                                                                                            answersVisible: answersVisible,
                                                                                        })
                                                                                    }}><span className='font-20 ml-1' style={{ verticalAlign: '6px' }}>Show answers</span></Checkbox>

                                                                            </div>
                                                                            <div ref={el => (this.quizComponentRefs[quizKey] = el)}>
                                                                                <div className='print-student-resource'>
                                                                                    {assessment.hasOwnProperty('version') &&
                                                                                        (assessment.version === '3.0' || assessment.version === '4.0') ?
                                                                                        this.state.answersVisible.hasOwnProperty(quizKey) && this.state.answersVisible[quizKey] ?
                                                                                            <StudentResource
                                                                                                key={assessment.id + '-answers-visible' + (this.state.printingQuizKey === quizKey ? '-print' : '')}
                                                                                                savedState={{ showAllCorrectAnswers: true, survey: 'good' }}
                                                                                                htmlSource={assessment.docs}
                                                                                                disableSplitView={this.state.printingQuizKey === quizKey} />
                                                                                            :
                                                                                            <StudentResource
                                                                                                key={assessment.id + '-answers-hidden' + (this.state.printingQuizKey === quizKey ? '-print' : '')}
                                                                                                htmlSource={assessment.docs}
                                                                                                disableSplitView={this.state.printingQuizKey === quizKey} />
                                                                                        : ''}
                                                                                </div>
                                                                            </div>
                                                                            {!(assessment.hasOwnProperty('version') &&
                                                                                (assessment.version === '3.0' || assessment.version === '4.0')) &&
                                                                                assessment.docs && assessment.docs.map((lessonPlanItem, idx) => {
                                                                                    return <div className={'font-black font-20 br-4 mb-50' + (idx === 0 ? ' mt-2' : '')}
                                                                                        key={'assessment-idx-' + idx}>
                                                                                        <div className='font-24'>Question {idx + 1}</div>
                                                                                        <DocumentDelegator
                                                                                            document={lessonPlanItem}
                                                                                        />
                                                                                    </div>
                                                                                })}
                                                                        </div>
                                                                    </Tabs.TabPane>
                                                                })}
                                                            </Tabs>
                                                        </div>
                                                    </div>
                                                    : ''}
                                            </div>
                                            : ''}
                                    </div>}
                            </Content>
                        </Layout>
                    </Layout>
                    : ''}
            </div>
        )
    }
}
export default PacingGuideLessonPlanV3